// 旧-自动加载
// const modules = {}
// try {
//   const req = require.context('./', true, /all\-source\.js$/)

//   req.keys().forEach((key) => {
//     if (key !== './index.js') {
//       const parts = key.split('/')
//       if (parts.length > 2) {
//         modules[parts[1]] = req(key).default
//       }
//     }
//   })
// } catch (e) {
//   console.warn('require.context not available, using manual import method')
// }

// 新-按需加载
// prettier-ignore
const modules = {}

const baseIconLoaders = {
  echo: () => import(/* webpackChunkName: "chunk-icon-echo" */ './echo/all-source.js'),
  joychat: () => import(/* webpackChunkName: "chunk-icon-joychat" */ './joychat/all-source.js'),
  joyu: () => import(/* webpackChunkName: "chunk-icon-joyu" */ './joyu/all-source.js'),
  kiko: () => import(/* webpackChunkName: "chunk-icon-kiko" */ './kiko/all-source.js'),
  vava: () => import(/* webpackChunkName: "chunk-icon-vava" */ './vava/all-source.js'),
  vibeo: () => import(/* webpackChunkName: "chunk-icon-vibeo" */ './vibeo/all-source.js'),
  whonow: () => import(/* webpackChunkName: "chunk-icon-whonow" */ './whonow/all-source.js'),
}

export async function loadBaseIcon(packageName) {
  const loader = baseIconLoaders[packageName]
  if (!packageName || !loader) {
    return
  }

  // 存在，不再加载
  const existedPackage = modules[packageName]
  if (existedPackage && Object.keys(existedPackage).length > 0) {
    return
  }

  const iconModule = await loader()
  modules[packageName] = iconModule.default
}

export default modules
